import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { base64ToBlob } from "helpers/base64ToBlob";
import { FC, useCallback, useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import theme from "theme";
import PrimaryButton from "../PrimaryButton";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface RenderPdfPreviewProps {
  data: string;
}

export const RenderPdfPreview: FC<RenderPdfPreviewProps> = (props) => {
  const { data } = props;
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const changePage = useCallback((offset: number) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }, []);

  const previousPage = useCallback(() => {
    changePage(-1);
  }, [changePage]);

  const nextPage = useCallback(() => {
    changePage(1);
  }, [changePage]);

  const onDocumentLoadSuccess = useCallback(({ numPages }: { numPages: number }): void => {
    setError(null);
    setNumPages(numPages);
    setPageNumber(1);
    setLoading(false);
  }, []);

  const onDocumentLoadError = useCallback((error: any) => {
    console.log(error);
    setError(error);
    setLoading(false);
  }, []);

  const fileUrl = useMemo(() => {
    const blob = base64ToBlob(data);
    return URL.createObjectURL(blob);
  }, [data]);

  return (
    <>
      <div
        style={{
          paddingBottom: "45px",
        }}
      >
        <Document
          file={fileUrl}
          onLoadStart={() => setLoading(true)}
          onLoadError={onDocumentLoadError}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <Page pageNumber={pageNumber} scale={1} />
        </Document>
      </div>
      {error === null && !loading && numPages > 1 && (
        <div
          style={{
            position: "fixed",
            bottom: "5%",
            left: 0,
            right: 0,
            zIndex: "2",
            alignItems: "center",
            textAlign: "center",
            flexDirection: "column",
            margin: "0 auto",
            width: "185px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              background: "#fff",
              borderRadius: theme.shape.borderRadius,
              boxShadow: theme.shadows[12],
            }}
          >
            <PrimaryButton
              disabled={pageNumber <= 1}
              onClick={previousPage}
              sx={{
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                margin: 0,
              }}
            >
              <ArrowBackIosNewIcon />
            </PrimaryButton>
            <span
              style={{
                justifyContent: "center",
                padding: "0, .5em",
                whiteSpace: "nowrap",
              }}
            >
              {pageNumber || (numPages ? 1 : "--")} <FormattedMessage id="general.of" />{" "}
              {numPages || "--"}
            </span>
            <PrimaryButton
              disabled={pageNumber >= numPages!}
              onClick={nextPage}
              sx={{
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                margin: 0,
              }}
            >
              <ArrowForwardIosIcon />
            </PrimaryButton>
          </div>
        </div>
      )}
    </>
  );
};
